/*!
  Atom, by Koding Themes
  internationalization.js
  https://kodingthemes.com
*/

document.addEventListener("DOMContentLoaded", function() {
  var languageForm = document.querySelector('.shopify-language-form');
  var currencyForm = document.querySelector('.shopify-currency-form');

  //language selector
  if (languageForm != null) {
    languageForm.onchange = function(e) {
      e.stopPropagation();
      new Noty({
        theme: 'nest',
        type: 'success',
        timeout: 1000,
        layout: 'topRight',
        text: window.theme.languageChanged,
      }).show();
      languageForm.querySelector("input#language_code").value = languageForm.querySelector("select").value;
      languageForm.submit();
    };
  }

  //currency selector
  if (currencyForm != null) {
    currencyForm.onchange = function(e) {
      e.stopPropagation();
      new Noty({
        theme: 'nest',
        type: 'success',
        timeout: 1000,
        layout: 'topRight',
        text: window.theme.currencyChanged,
      }).show();
      currencyForm.querySelector("input#countryCode").value = currencyForm.querySelector("select").value;
      currencyForm.submit();
    };
  }
});
